module.exports = __webpack_public_path__ + "img/wyb_banner_zh-cn.3f8bfba0.png";